"use client";

/**
 * DiscoveryCollabsRow 컴포넌트
 * @description Discovery 의 콜랩 가로줄. 시안 `3041:2412`. 표기 문구는 앱 것을 그대로 쓴다
 *   (`explore:spotlightCollabs`). 첫 장은 서버 컴포넌트(`DiscoveryCollabs`)가 준다.
 *
 *   줄을 끝까지 밀면 다음 장이 뒤에 붙는다 — 더 볼 것이 없으면 거기서 멈춘다.
 */
import { memo, useCallback } from "react";

import { discoveryCollabsStyles } from "./DiscoveryCollabs.styles";
import type { DiscoveryCollabsRowProps } from "./DiscoveryCollabs.types";
import DiscoveryCollabsCard from "./DiscoveryCollabsCard";

import { COLLAB_ROW_PAGE_SIZE } from "./DiscoveryCollabs.constants";
import { useSliderPages } from "../useSliderPages";

import { EXPLORE_COPY } from "../../constants/copy";
import { loadCollabs, type CollabListItem } from "@/domains/core/collab";
import { Reveal, Section, SectionHeader, Slider } from "@/shared/ui";

const keyExtractor = (collab: CollabListItem): string =>
  String(collab.collabId);

const loadPage = (cursor: string) => loadCollabs(COLLAB_ROW_PAGE_SIZE, cursor);

const DiscoveryCollabsRow = memo<DiscoveryCollabsRowProps>(({ firstPage }) => {
  const { items, loadMore } = useSliderPages(firstPage, loadPage);

  const renderItem = useCallback(
    (collab: CollabListItem, index: number) => (
      <DiscoveryCollabsCard collab={collab} index={index} />
    ),
    [],
  );

  return (
    <div className={discoveryCollabsStyles.root}>
      <Section padding="sm">
        <Reveal>
          <SectionHeader title={EXPLORE_COPY.spotlightCollabs} />
        </Reveal>
      </Section>
      <Slider
        navigationLabel={EXPLORE_COPY.spotlightCollabs}
        padding="sm"
        data={items}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        onEndReached={loadMore}
      />
    </div>
  );
});

DiscoveryCollabsRow.displayName = "DiscoveryCollabsRow";

export default DiscoveryCollabsRow;
